'use client'

import handleIntent from '@/lib/react-native/services/react-native.intent.client'
import { createIntent, type WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { onError } from '@apollo/client/link/error'

export function createShowMaintenanceIntent(): WebViewIntent {
  return createIntent('SHOW_MAINTENANCE')
}

/**
 * Apollo link that watches for 503 responses
 */
export function createReactNativeMaintenanceLink() {
  return onError(({ networkError, operation }) => {
    if (!networkError || !('statusCode' in networkError) || networkError.statusCode !== 503) {
      return
    }

    console.error(`🔴 [MAINTENANCE]: 503 received for operation "${operation.operationName}"`, {
      statusCode: networkError.statusCode,
      message: networkError.message,
    })

    handleIntent(createShowMaintenanceIntent())
  })
}
